/**
 * Cart recommendations — "You may also like" (cart drawer + cart page)
 *
 * Uses event delegation on `document` because the cards live inside sections
 * (cart-drawer / cart-template) that get fully replaced via innerHTML by the
 * theme's existing cart-update pipeline — delegated listeners keep working
 * without any re-binding after that swap.
 */
(function () {
  if (window.__tfCartRecoInited) return;
  window.__tfCartRecoInited = true;

  function formatCartRecoMoney(cents) {
    if (typeof formatMoney === 'function' && window.MinimogSettings && window.MinimogSettings.money_format) {
      return formatMoney(cents, window.MinimogSettings.money_format);
    }
    return cents;
  }

  /* ─── Variant select → sync price + add button state ─── */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-tf-reco-variant-select]');
    if (!select) return;

    var card = select.closest('[data-tf-reco-card]');
    if (!card) return;

    var option = select.options[select.selectedIndex];
    var addButton = card.querySelector('[data-tf-reco-add]');
    var priceEl = card.querySelector('[data-tf-reco-price]');
    var compareEl = card.querySelector('[data-tf-reco-compare]');
    var labelEl = addButton && addButton.querySelector('[data-tf-reco-add-label]');

    if (priceEl && option.dataset.price) {
      priceEl.textContent = formatCartRecoMoney(option.dataset.price);
    }

    var comparePrice = parseInt(option.dataset.compareAtPrice, 10) || 0;
    var price = parseInt(option.dataset.price, 10) || 0;
    if (compareEl) {
      if (comparePrice > price) {
        compareEl.textContent = formatCartRecoMoney(comparePrice);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    if (addButton) {
      addButton.dataset.variantId = option.value;
      addButton.disabled = option.disabled;
      if (labelEl) {
        labelEl.textContent = option.disabled
          ? (window.MinimogStrings ? window.MinimogStrings.soldOut : 'Sold out')
          : (window.MinimogStrings ? window.MinimogStrings.addToCart : 'Add to Cart');
      }
    }
  });

  /* ─── Add to cart ─── */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tf-reco-add]');
    if (!button || button.disabled || button.classList.contains('m-spinner-loading')) return;

    event.preventDefault();

    var card = button.closest('[data-tf-reco-card]');
    var variantId = button.dataset.variantId;
    if (!variantId) return;

    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', sectionsToBundle);
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    button.classList.add('m-spinner-loading');
    button.disabled = true;
    if (card) card.classList.add('is-adding');

    fetch(window.MinimogSettings.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          window.MinimogTheme.Notification.show({
            target: card || document.body,
            method: 'appendChild',
            type: 'error',
            message: response.message || response.description,
            last: 3000,
            sticky: !card,
          });
          button.classList.remove('m-spinner-loading');
          button.disabled = false;
          if (card) card.classList.remove('is-adding');
          return;
        }

        window.MinimogTheme.Notification.show({
          target: document.body,
          method: 'appendChild',
          type: 'success',
          message: window.MinimogStrings.itemAdded,
          last: 2500,
          sticky: true,
        });

        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
          cart: response,
          productVariantId: variantId,
        });

        document.dispatchEvent(
          new CustomEvent('product-ajax:added', { detail: { product: response } })
        );
      })
      .catch(function (error) {
        console.error(error);
        button.classList.remove('m-spinner-loading');
        button.disabled = false;
        if (card) card.classList.remove('is-adding');
      });
  });
})();
